var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobRequestsMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.301,
    height: 22.161,
    viewBox: "0 0 25.301 22.161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14639054"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3212",
    "data-name": "Rectangle 3212",
    width: 10.89,
    height: 10.89,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98432",
    "data-name": "Group 98432",
    transform: "translate(-189.354 -415.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26814",
    "data-name": "Group 26814",
    transform: "translate(203.765 415.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10051",
    "data-name": "Group 10051",
    clipPath: "url(#clip-path-14639054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13050",
    "data-name": "Path 13050",
    d: "M10.763,10.121,8.057,7.415a4.541,4.541,0,1,0-.641.641l2.706,2.706a.453.453,0,0,0,.641-.641M4.549,8.175A3.627,3.627,0,1,1,8.176,4.548,3.627,3.627,0,0,1,4.549,8.175",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27000",
    "data-name": "Group 27000",
    transform: "translate(189.354 420.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27009",
    "data-name": "Group 27009"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62600",
    "data-name": "Path 62600",
    d: "M13.263,2.792h-.768A3.49,3.49,0,0,0,9.074,0h-1.4a3.5,3.5,0,0,0-3.42,2.792H3.49A3.491,3.491,0,0,0,0,6.282v6.98a3.491,3.491,0,0,0,3.49,3.49h9.773a3.491,3.491,0,0,0,3.49-3.49V6.282a3.491,3.491,0,0,0-3.49-3.49M7.678,1.4h1.4a2.1,2.1,0,0,1,1.975,1.4H5.7A2.1,2.1,0,0,1,7.678,1.4m7.678,11.867a2.1,2.1,0,0,1-2.094,2.094H3.49A2.1,2.1,0,0,1,1.4,13.263V6.282A2.1,2.1,0,0,1,3.49,4.188h9.773a2.1,2.1,0,0,1,2.094,2.094Z",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobRequestsMenuIcon);
export default __webpack_public_path__ + "static/media/job-requests-menu-icon.3b944860abdfd1c6e5b6a1138b785fe2.svg";
export { ForwardRef as ReactComponent };